


























import {
  defineComponent,
  PropType,
  ref,
  computed,
  useFetch
} from '@nuxtjs/composition-api'
import { useDep } from '~/compositions/dependency-container'
import { useLogger } from '~/compositions/logger'
import {
  AccessToggle,
  AccessToggleIdentifier
} from '~/models/user/access-toggles'
import AccessTogglesService from '~/services/user/AccessTogglesService'
import CUserAccessTogglesModalItem from '~/components/shared/configurable/access-toggle/CUserAccessTogglesModalItem.vue'

export default defineComponent({
  components: {
    CUserAccessTogglesModalItem
  },
  props: {
    identifier: {
      type: [String, Number] as PropType<AccessToggleIdentifier>,
      required: true
    }
  },
  setup(props) {
    const accessTogglesService = useDep(AccessTogglesService)
    const logger = useLogger()
    const accessToggles = ref<AccessToggle[]>([])
    const query = ref('')

    const displayedAccessToggles = computed(() => {
      if (query.value.length > 0) {
        return accessToggles.value.filter(a =>
          a.disallowReasonDescription
            .toLowerCase()
            .includes(query.value.toLowerCase())
        )
      }
      return accessToggles.value
    })

    const loadAccessToggles = async () => {
      try {
        const {
          accessToggles: value
        } = await accessTogglesService.getAccessToggles(props.identifier)
        accessToggles.value = value
      } catch (error) {
        logger.captureError(error as any)
      }
    }

    useFetch(loadAccessToggles)

    return {
      loadAccessToggles,
      accessToggles,
      query,
      displayedAccessToggles
    }
  }
})
